import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { ArrowLeft, Mail } from 'lucide-react';
import { authApi } from '../../../api';

const ForgotPasswordPage = ({ error: initialError = '', message = '' }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState(initialError);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const logoSrc = `${process.env.PUBLIC_URL || ''}/assets/images/chat_logo.png`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);
    try {
      await authApi.forgotPassword(email);
      navigate('/otp', { state: { email, message: 'We\'ve sent an OTP to your registered Email Address. Please check your email and enter the code below.' } });
    } catch (err) {
      const errMsg = err?.response?.data?.message || 'Unable to send OTP. Please try again.';
      setError(errMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        backgroundImage: `linear-gradient(135deg, rgba(37, 211, 102, 0.65) 0%, rgba(26, 160, 80, 0.7) 50%, rgba(20, 126, 63, 0.75) 100%), url(${process.env.PUBLIC_URL || ''}/assets/images/whatsapp_bg1.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 480,
          borderRadius: 4,
          boxShadow: 10,
          backgroundColor: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(6px)',
          border: '1px solid rgba(255,255,255,0.4)',
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={2} alignItems="center">
            <Box sx={{ alignSelf: 'flex-start' }}>
              <Button
                variant="text"
                startIcon={<ArrowLeft size={18} />}
                href="/login"
                sx={{ px: 0, minWidth: 0 }}
              >
                Back
              </Button>
            </Box>
            <Box component="img" src={logoSrc} alt="ChattyBO" sx={{ height: 40 }} />
            <Typography variant="h6">Verify your Email</Typography>
            {error && error.length > 0 && (
              <Alert severity="error" sx={{ width: '100%' }}>
                {error}
              </Alert>
            )}
            {message && message.length > 0 && (
              <Alert severity="info" sx={{ width: '100%' }}>
                {message}
              </Alert>
            )}
          </Stack>

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Stack spacing={2}>
              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Mail size={16} />
                    </InputAdornment>
                  ),
                }}
              />

              <Stack direction="row" justifyContent="flex-end">
                <Button type="submit" variant="contained" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send OTP'}
                </Button>
              </Stack>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ForgotPasswordPage;
